import axios, { type AxiosError } from 'axios';
import { supabase } from './supabase';

export const api = axios.create({
  baseURL: (import.meta.env.VITE_API_URL as string | undefined) ?? '',
  withCredentials: true,
});

api.interceptors.request.use(async (config) => {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error: AxiosError<{ error?: { code?: string; message?: string } }>) => {
    if (error.response?.status === 401) {
      await supabase.auth.signOut();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export interface ApiErrorBody {
  code: string;
  message: string;
  details?: unknown;
}

export function readApiError(err: unknown): ApiErrorBody {
  if (axios.isAxiosError(err)) {
    const body = (err.response?.data as { error?: ApiErrorBody } | undefined)?.error;
    if (body) return body;
    return { code: 'NETWORK', message: err.message };
  }
  return { code: 'UNKNOWN', message: err instanceof Error ? err.message : 'Unknown error' };
}
